/**
 * @file
 *
 * This file describes only the 'Action Types' and his 'Actions Creators'
 * https://redux.js.org/docs/basics/Actions.html
 * @author JPablo
 */

/*
* Action Types
*/

import { FiltroAgrupadora } from "../modelo/Agrupadora";
import { Datos} from "../../../documentos/modelo/Documento";


export const ERROR_CONSULTANDO_REPORTE_AGRUPADORAS = "ERROR_CONSULTANDO_REPORTE_AGRUPADORAS";
export const CONSULTAR_PARAMETROS_AGRUPADORAS = "CONSULTAR_PARAMETROS_AGRUPADORAS";
export const PARAMETROS_CONSULTADO_AGRUPADORAS = "PARAMETROS_CONSULTADO_AGRUPADORAS";

export const OBTENER_XLS_PARAMETROS_AGRUPADORAS = "OBTENER_XLS_PARAMETROS_AGRUPADORAS";
export const XLS_OBTENIDO_AGRUPADORAS = "XLS_OBTENIDO_AGRUPADORAS";
export const ERROR_OBTENIENDO_XLS_AGRUPADORAS = "ERROR_OBTENIENDO_XLS_AGRUPADORAS";

/*
* Actions Creators
* Note that's a good practice type the Action fields {..., name: name} instead of {..., name}
*/

export const consultarParametros = (filtroAgrupadora: FiltroAgrupadora) => ({type: CONSULTAR_PARAMETROS_AGRUPADORAS, filtro: filtroAgrupadora});
export const parametrosConsultado = (documentos: Array<Datos>,paginas:number) => ({type: PARAMETROS_CONSULTADO_AGRUPADORAS, documentos, paginas});
export const errorConsultandoReporte = () => ({type: ERROR_CONSULTANDO_REPORTE_AGRUPADORAS});


export const obtenerXLSParametros = (filtroAgrupadora: FiltroAgrupadora) => ({type: OBTENER_XLS_PARAMETROS_AGRUPADORAS, filtro: filtroAgrupadora});
export const xlsObtenido = () => ({type: XLS_OBTENIDO_AGRUPADORAS});
export const errorObteniendoXLS = () => ({type: ERROR_OBTENIENDO_XLS_AGRUPADORAS});



// WEBPACK FOOTER //
// ./src/co/sura/dominio/parametros/consultar_parametros/modulos/parametrosActions.ts